import React from 'react';
import styled from 'styled-components';
import { AlertIcon, colors } from '@commonsku/styles';

import { InfoTooltip } from './InfoTooltip';

const REFUND_ERROR_TOOLTIP_CONTENT = {
    CARD_NETWORK: {
        title: 'Card network error',
        body: 'The refund was declined by the card network. Check with your payment provider for next steps and retry once the issue is resolved. If you need help, contact our support team.',
    },
    SYSTEM: {
        title: 'System error',
        body: "Something went wrong on our end. Wait a few minutes and try again. If the problem persists, contact support via chat.",
    },
};

const TooltipTitle = styled.div`
    font-weight: 700;
    margin-bottom: 4px;
`;

const RefundAlertIcon = () => <AlertIcon size="small" />;

type RefundFailureTooltipProps = {
    refundErrorType?: keyof typeof REFUND_ERROR_TOOLTIP_CONTENT | null;
    tooltipId: string;
};

export const RefundFailureTooltip = ({
    refundErrorType,
    tooltipId,
}: RefundFailureTooltipProps) => {
    const content = REFUND_ERROR_TOOLTIP_CONTENT[refundErrorType ?? 'SYSTEM']
        ?? REFUND_ERROR_TOOLTIP_CONTENT.SYSTEM;

    return (
        <InfoTooltip
            tooltipId={tooltipId}
            tooltipContent={(
                <div>
                    <TooltipTitle>{content.title}</TooltipTitle>
                    <div>{content.body}</div>
                </div>
            )}
            ariaLabel="Refund failed"
            icon={RefundAlertIcon}
            color={colors.errors.main}
            size={20}
            maxWidth={280}
        />
    );
};
